import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { ExcelService } from '../excel.service';
import { HandlerService } from '../handler.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-manage-items',
  templateUrl: './manage-items.component.html',
  styleUrls: ['./manage-items.component.scss'],
})
export class ManageItemsComponent {
  displayedColumns :string[]= ['name','price','sku','purchaseCategory','product','brand','color','size'];
  dataSource: any;
  sort;
  items:any=[];
  loader:boolean=false;
  search:any=[];
  editId;
  optionpop: boolean = false;
  excelpop: boolean = false;
  input: boolean = false;
  sizeObj:any=[];
  colorObj:any=[];
  cardView;
  excelData: any = [];
  itemName;
  product;
  sku: any =[];
  avaliableQty: any =[];
  brand;
  mrp: any =[];
  salePrice: any =[];
  promotion;
  hsn: any =[];
  itemDatadummy: any = [];
  itemData: any = [];
  arrayBuffer: any;
  junk: any = [];
  file: File;
  stockOutQty;
  id;
  productId;
  productName;
  productObj:any;
  category;
  cateName;
  cateId;
  


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  constructor(public service:ApiService, 
              public handler:HandlerService,
              public router:Router,
              private platform:Platform,
              private excelService: ExcelService,
              public auth:AuthService) {    }

  ionViewWillEnter() {

    if (this.platform.ANDROID || this.platform.IOS) {
      this.cardView = 'true';
    }
    else{
      if(localStorage.getItem('config')){
        var con = JSON.parse(localStorage.getItem('config'));
        let y = con.find(res => res.shortCdConst == "DFLTCARDLYT");
        if(y){
          this.cardView=y.userValue;
        }
        else{
          this.cardView = 'true';
        }
       
      }
    }
    this.loader = true;
    this.getProductObject();
    this.getCategory();

  }

  getAllItems(){
    this.service.getItemProduct().subscribe(res=>{

      if(res){
        this.items = res;
        this.items.map(dat=>{
          this.category.map(dat1 => {
            if (dat1.id == dat.purchaseCategory) {
              Object.assign(dat, { cateName: dat1.name })
            }
        })
          })
          this.items.map(dat=>{
            this.productObj.map(dat1 => {
              if (dat1.id == dat.productId) {
                Object.assign(dat, { productName: dat1.name })
              }
          })
            })
         this.dataSource = new MatTableDataSource(this.items);
      }
     this.loader=false;
    },err=>{
      this.loader = false;
      this.handler.err(err)
    })
    this.service.getAllcolor().subscribe(res => {
      this.colorObj = res;
    },
      err => {
        this.handler.err(err);
      })
      this.service.getAllsize().subscribe(res => {
        this.sizeObj = res;
      },
        err => {
          this.handler.err(err);
        })
        this.service.getAllProduct().subscribe(res =>{
          this.product = res;
        })
        this.service.getAllbrand().subscribe(res => {
          this.brand = res;
        })
  }

  getProductObject(){
    this.loader=true;
    this.service.getAllProduct().subscribe(res => {
      this.productObj = res;
   this.getCategory();
    })
  }

  
  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.getAllItems();
     })
  }

  generateTable(tableData: any) {
    this.dataSource = new MatTableDataSource(this.items);
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      let matchFound = false;
      for (let column of this.displayedColumns) {
        if(column in data) {
          if(data[column]) {
            matchFound = (matchFound || data[column].toString().trim().toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1)
          }
        }
      }
      return matchFound;
    }
  }

  edit(id){
    this.router.navigate(['edit-item',id]);
  }
  copyitem(){
     this.optionpop = true;
  }
  getFranchisorItems(){
    this.loader=true;
    this.optionpop = false;
    this.router.navigate(['franchisor-item']);
  }
  createService(){       
    this.optionpop = false; 
    this.router.navigate(['services/create-service']);
  }
  viewChange(id) {
    if (id == 1) { this.cardView = 'true'; }
    else {this.cardView = 'false'; }
  }
  getColorName(id){
    if(this.colorObj && this.colorObj.length>0){
    let color=this.colorObj.find(res=>{return res.id==id})
    if(color)
    return color.name;
  }
}
  getSize(id){
    if(this.sizeObj && this.sizeObj.length>0){
    let a=this.sizeObj.find(res=>{return res.id==id})
    if(a)
    return a.name;
  }
}
exportAsXLSX(): void {
  this.items.map(res => {
    this.excelData.push({
      ProductName: res.name, Price: res.priceStr, SKU: res.sku,purchaseCategory: res.cateName,Brand: res.brand,Product: res.productName,Color:res.color,Size:res.size
    })
  })
  this.excelService.exportAsExcelFile(this.excelData, 'Items');
}
getFile() {
  let link = document.createElement("a");
  link.download = "uploadData";
  link.href = "assets/item.xlsx";
  link.click();
  this.input=true;
}
handleFile(files){
  this.file = files[0];
  this.Upload();
}
Upload(){
  let fileReader = new FileReader();
  fileReader.onload = (e) => {
    this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      var check = false;
      this.junk = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      let x=this.junk.PreferredLang;
      this.junk.forEach((element,i) => {
        this.itemDatadummy = {
        }
        var itemName = element.ItemName
        var sku = element.SKU
        var product = element.Product
        var brand = element.Brand
        var avaliableQty = element.AvaliableQty
        var mrp = element.MRP
        var price = element.SalePrice
        var hsn = element.HSN
        var itemtype = element.ItemType
        var pickByWgt = element.PickBy

        if(itemName){
          Object.assign(this.itemDatadummy,{itemName: element.ItemName})
        }
        else{
          Object.assign(this.itemDatadummy,{itemName: null})
          check = true;
        }
        if(sku){
          Object.assign(this.itemDatadummy,{sku: element.SKU})
        }
        else{
          Object.assign(this.itemDatadummy,{sku: null})
          check = true;
        }
        if(product){
          let pro = this.product.find(dat => dat.name ==product);
          Object.assign(this.itemDatadummy,{product: pro.id})
        }
        else{
          Object.assign(this.itemDatadummy,{product: null})
          check = true;
        }
        if(brand){
          let brandId = this.brand.find(dat => dat.name ==brand);
          Object.assign(this.itemDatadummy,{brand: brandId.id})
        }
        else{
          Object.assign(this.itemDatadummy,{brand: null})
          check = true;
        }
        if(avaliableQty){
          Object.assign(this.itemDatadummy,{avaliableQty: element.AvaliableQty})
        }
        else{
          Object.assign(this.itemDatadummy,{avaliableQty: null})
          check = true;
        }
        if(mrp){
          Object.assign(this.itemDatadummy,{mrp: element.MRP})
        }
        else{
          Object.assign(this.itemDatadummy,{mrp: null})
          check = true;
        }
        if(price){
          Object.assign(this.itemDatadummy,{price: element.SalePrice})
        }
        else{
          Object.assign(this.itemDatadummy,{price: null})
          check = true;
        }
        if(hsn){
          Object.assign(this.itemDatadummy,{hsn: element.HSN})
        }
        else{
          Object.assign(this.itemDatadummy,{hsn: null})
          check = true;
        }
        if(itemtype=='PRODUCT'){
          Object.assign(this.itemDatadummy,{itemtype: 1})
        }
        else{
          Object.assign(this.itemDatadummy,{itemtype: null})
          check = true;
        }
        if(pickByWgt=='PICKBYWGT'){
          Object.assign(this.itemDatadummy,{pickByWgt: true})
        }
        else{
          Object.assign(this.itemDatadummy,{pickByWgt: false})
        }
        this.pushToOverAll(this.itemDatadummy)
      });

  }
  fileReader.readAsArrayBuffer(this.file);
}
pushToOverAll(data){
 this.itemData.push(data)
}
excelsave(){
  var post;
  this.itemData.map(res =>{
    if(res.itemtype == 1) {
      post={
        name: res.itemName,
        sku:res.sku,
        stockOutQty:res.avaliableQty,
        markedPrice:res.mrp,
        price:res.price,
        hsn:res.hsn,
        productId:res.product,
        brand:res.brand,
        purchaseCategory:res.cateName,
        activeInd:true,
        pickByWgt:res.pickByWgt,
        type:1
      }
    }
    else{
      post={
        name: res.itemName,
        sku:res.sku,
        stockOutQty:res.avaliableQty,
        markedPrice:res.mrp,
        price:res.price,
        hsn:res.hsn,
        brand:res.brand,
        purchaseCategory:res.cateName,
        activeInd:true,
        type:2
      }
    }
  })
  this.service.createItem(post).subscribe(res => {
    this.handler.res("Item Created Successfully");
    this.optionpop = false;
    this.excelpop = false;
    this.file = undefined;
    this.ionViewWillEnter();
  
  })
}
stockout(item){
  item.stockOutQty=0
  this.service.updateItem(item.id,item).subscribe(res => {
   this.handler.res("Item Updated Successfully");
  this.router.navigate(['services']); 
  })

}
excelItem(){
  this.excelpop = true;
  this.optionpop = false;
  this.file = undefined;
}
ionViewWillLeave(){
  this.excelpop = false;
  this.file = undefined;
 
}

clear(){
  this.search="";
}
deleteProduct(id){
  this.loader=true;
  this.service.deletesize(id).subscribe(res=>{
    this.ionViewWillEnter()
   this.loader=false;
    this.handler.res("Deleted successfully")
 

  },
  err=>{
    this.handler.err(err)
    this.loader=false
  })
}

}
